import { GeneralToggle } from "../../../../../general";

// Values same as in `RedirectStatus` enum at the back.
const Status = {
    SUCCESSFUL: 'successful',
    FAILED: 'failed',
    FAILED_INTERNAL_ERROR: 'failed-internal-error',
    FAILED_WRONG_PASSWORD: 'failed-wrong-password',
    FAILED_CONV_NOT_ACTIVE: 'failed-conv-not-active',
    BLOCKED_BY_CPM: 'blocked-by-cpm',
    ALL: 'all',
}

const statuses = [
    {
        title: 'Successful',
        value: Status.SUCCESSFUL,
    },
    {
        title: 'Failed',
        value: Status.FAILED,
    },
    {
        title: 'Failed: Internal Error',
        value: Status.FAILED_INTERNAL_ERROR,
    },
    {
        title: 'Failed: Wrong Password',
        value: Status.FAILED_WRONG_PASSWORD,
    },
    {
        title: 'Failed: Conv Not Active',
        value: Status.FAILED_CONV_NOT_ACTIVE,
    },
    {
        title: 'Failed: Blocked by CPM',
        value: Status.BLOCKED_BY_CPM,
    },
    {
        title: 'All',
        value: Status.ALL,
    },
];

const StatusToggle = ({ status, setStatus, redirectStatuses }) => {
    const items = statuses.filter(item => redirectStatuses.includes(item.value));
    return (
        <GeneralToggle 
            label='Status' 
            value={status} 
            setValue={setStatus}
            items={items}
            fixedMinWidth={true}
        />
    );
}

export default StatusToggle;